import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { AvailableTabProperties } from '../../interface/device-management.interface';
import { useAppSelector } from '../../redux/hooks';

import DeviceDetails from './components/device-details/DeviceDetails';
import DeviceManagementTabs from './components/DeviceManagementTabs';
import DeviceSearch from './components/DeviceSearch';
import OcppConsole from './components/ocpp-console/OcppConsole';

/**
 * Component to display the device management page
 * @returns
 */
function DeviceManagement() {
  const { t } = useTranslation('devices');
  const navigate = useNavigate();
  const { tab: deviceTab, id } = useParams<{ tab: string; id: string }>();
  const { selectedChargingPoint } = useAppSelector((s) => s.device);
  const { type } = useParams<{ type: string }>();
  const { userCustomId } = useParams<{ userCustomId: string }>();
  const [containerTabs, setContainerTabs] = useState<AvailableTabProperties[]>([
    {
      label: t('deviceDetails'),
      key: 'device-details',
      isActive: false,
    },
    // {
    //   label: 'Device Setting',
    //   key: 'device-setting',
    //   isActive: false,
    // },
    // {
    //   label: 'Device Health',
    //   key: 'device-health',
    //   isActive: false,
    // },
    {
      label: t('oCPPConsole'),
      key: 'ocpp-console',
      isActive: false,
    },
  ]);

  const { pathname, search } = useLocation();

  /**
   * Function to switch the tab
   * @param {string} key
   */
  const handleSwitchTab = (key: string, navigateRequire: boolean = true) => {
    const isExpanded = pathname.includes('device-expanded');
    const basePath = isExpanded ? 'device-expanded' : 'device';

    setContainerTabs((previousTabs: AvailableTabProperties[]) =>
      previousTabs.map((tab) => {
        if (tab.key === key) {
          if (navigateRequire)
            if (type && userCustomId) {
              navigate({
                pathname: `/ev-admin/end-consumer/${type}/profile/${userCustomId}/${basePath}/${id}/${tab.key}`,
                search: search || `?searchBy=${selectedChargingPoint?.name}`,
              });
            } else {
              navigate({
                pathname: `/ev-admin/device-management/${basePath}/${id}/${tab.key}`,
                search: search || `?searchBy=${selectedChargingPoint?.name}`,
              });
            }
          return {
            ...tab,
            isActive: true,
          };
        }
        return {
          ...tab,
          isActive: false,
        };
      }),
    );
  };

  useEffect(() => {
    handleSwitchTab(deviceTab || 'device-details', false);
  }, []);

  return (
    <div className="device-management-wrap">
      <div className="device-management-container">
        <DeviceManagementTabs
          containerTabs={containerTabs}
          handleSwitchTab={handleSwitchTab}
          deviceId={id || selectedChargingPoint?.id}
        />
        <DeviceSearch />
        <div className="device-management-content">
          {(() => {
            const activeTab = containerTabs.find((tab) => tab.isActive)?.key || 'device-details';

            let deviceContent = null;
            switch (activeTab) {
              case 'device-details':
                deviceContent = <DeviceDetails />;
                break;
              case 'ocpp-console':
                deviceContent = <OcppConsole />;
                break;
              default:
                deviceContent = <DeviceDetails />;
                break;
            }
            return deviceContent;
          })()}
        </div>
      </div>
    </div>
  );
}

export default DeviceManagement;
